import Header from "./Header";
import Footer from "./Footer";
import { FiTrash2 } from "react-icons/fi";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
function CartPage() {
const navigate = useNavigate();
const [qty,setQty] = useState(1);
const [cart, setCart] = useState([]);
const [subtotal, setSubtotal] = useState(0);
const [loading, setLoading] = useState(true);
const [updatingQtyId, setUpdatingQtyId] = useState(null);
const price = 2399;
const total = subtotal;
const getCartUserData = () => {
  const storedUser = JSON.parse(localStorage.getItem("user") || "null");

  const user_id = storedUser?.id || "";
  const guest_id = localStorage.getItem("guest_id") || "";

  return user_id
    ? { user_id, guest_id: "" }
    : { guest_id, user_id: "" };
};
const fetchCart = async (showLoader = true) => {
  try {
    if (showLoader) setLoading(true);

    const res = await fetch(
      "https://aethearia.store/superadmin/api/cart-list",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...getCartUserData(),
        }),
      }
    );

    const data = await res.json();
    console.log("Cart API:", data);

    if (data.status) {
      const sortedCart = [...(data.data || [])].sort(
        (a, b) => Number(b.cart_id) - Number(a.cart_id)
      );

      setCart(sortedCart);
      setSubtotal(Number(data.subtotal));
    } else {
      setCart([]);
      setSubtotal(0);
    }
  } catch (err) {
    console.error("Cart fetch error:", err);
  } finally {
    if (showLoader) setLoading(false);
  }
};
const updateCartQty = async (cart_id, newQty) => {
  // If quantity becomes 0, remove item from cart
  if (newQty === 0) {
    await deleteCartItem(cart_id);
    return;
  }

  if (newQty < 1) return;

  const oldCart = [...cart];
  const oldSubtotal = subtotal;

  const updatedCart = cart.map((item) => {
    if (Number(item.cart_id) === Number(cart_id)) {
      const itemPrice = Number(item.price || 0);

      return {
        ...item,
        quantity: newQty,
        line_total: (itemPrice * newQty).toFixed(2),
      };
    }

    return item;
  });

  const updatedSubtotal = updatedCart.reduce((total, item) => {
    return total + Number(item.line_total || 0);
  }, 0);

  // Instant UI update
  setCart(updatedCart);
  setSubtotal(updatedSubtotal);
  setUpdatingQtyId(cart_id);

  try {
    const res = await fetch(
      "https://aethearia.store/superadmin/api/update-cart",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...getCartUserData(),
          cart_id,
          quantity: newQty,
        }),
      }
    );

    const data = await res.json();

    console.log("Update cart:", data);

    if (data.status) {
      await fetchCart(false);

      window.dispatchEvent(
        new Event("cartWishlistUpdated")
      );
    } else {
      // Rollback
      setCart(oldCart);
      setSubtotal(oldSubtotal);

      alert(data.message || "Update failed");
    }
  } catch (err) {
    console.error("Update cart error:", err);

    // Rollback
    setCart(oldCart);
    setSubtotal(oldSubtotal);
  } finally {
    setUpdatingQtyId(null);
  }
};
const deleteCartItem = async (cart_id) => {
  const oldCart = [...cart];

  const updatedCart = cart.filter(
    (item) => Number(item.cart_id) !== Number(cart_id)
  );

  // instant cart page update
  setCart(updatedCart);

  // instant header cart count update
  window.dispatchEvent(
    new CustomEvent("cartWishlistUpdated", {
      detail: {
        cartCount: updatedCart.length,
      },
    })
  );

  try {
    const res = await fetch(
      "https://aethearia.store/superadmin/api/delete-cart",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          ...getCartUserData(),
          cart_id,
        }),
      }
    );

    const data = await res.json();

    if (data.status) {
      await fetchCart();

      window.dispatchEvent(
        new Event("cartWishlistUpdated")
      );
    } else {
      setCart(oldCart);

      window.dispatchEvent(
        new CustomEvent("cartWishlistUpdated", {
          detail: {
            cartCount: oldCart.length,
          },
        })
      );

      alert(data.message || "Delete failed");
    }
  } catch (err) {
    console.error("Delete cart error:", err);

    setCart(oldCart);

    window.dispatchEvent(
      new CustomEvent("cartWishlistUpdated", {
        detail: {
          cartCount: oldCart.length,
        },
      })
    );
  }
};
useEffect(() => {
  fetchCart();
}, []);
return(
<>
<style>{`
/* =========================================================
   CART PAGE - BASE
========================================================= */
  .product-category {
  display: none;
}
.cart-page {
  min-height: 100vh;
  padding: 120px 0 60px;
  color: #4c144e;
  margin-top: 160px;
}

.cart-page.container {
  max-width: 1320px;
  margin: 60px auto 0;
}

.cart-page h1 {
  text-transform: capitalize !important;
}


/* =========================================================
   CART LAYOUT
========================================================= */

.cart-layout {
  display: grid;
  grid-template-columns: 1fr 0.60fr;
  gap: 100px;
}


/* =========================================================
   CART TABLE
========================================================= */

.cart-table {
  width: 100%;
}


/* =========================================================
   CART HEADER
========================================================= */

.cart-head {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr) 150px 160px 100px;
  border-bottom: 1px solid #4c144e;
}

.cart-head .cart-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 14px 10px;
  color: rgba(77, 67, 56, 1);
  font-weight: 100;
  font-size: 14px;
}

.cart-head .cart-cell:first-child {
  justify-content: flex-start;
  text-align: left;
}


/* =========================================================
   CART PRODUCT ROW - DESKTOP
========================================================= */

.cart-row {
  display: grid;
  grid-template-columns: 120px minmax(0, 1fr) 150px 160px 100px;
  align-items: center;
  border-bottom: 1px solid #4c144e;
}


/* =========================================================
   CART CELLS
========================================================= */

.cart-cell {
  padding: 14px 10px;
  display: flex;
  align-items: center;
  font-weight: 100;
  font-size: 14px;
}


/* =========================================================
   PRODUCT IMAGE
========================================================= */

.cart-row > .cart-cell:nth-child(1) {
  grid-column: 1;
  // display: flex;
  // align-items: center;
  // justify-content: center;
}

.cart-img {
  width: 120px;
  height: 100px;
  object-fit: contain;
  margin: auto;
  cursor: pointer;
}


/* =========================================================
   PRODUCT INFORMATION
========================================================= */

.cart-row > .product-info {
  grid-column: 2;
  display: flex;
  // flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  // gap: 4px;
  // min-width: 0;
}
  .cart-row > .product-category {
  grid-column: 3;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.product-info strong {
  font-size: 15px;
  font-weight: 100;
  color: rgba(77,67,56,1);
}

.product-category {
  display: block;
  margin: 0;
  font-size: 14px;
  color: rgba(77,67,56,1);
  font-weight: 400;
}


/* =========================================================
   QUANTITY
========================================================= */

.cart-row > .quantity-cell {
  grid-column: 4;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qty-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid #4c144e;
  overflow: hidden;
}

.qty-box button,
.qty-number {
  width: 38px;
  height: 38px;
  background: transparent;
  color: #4c144e;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}

.qty-number {
  background: rgba(255, 255, 255, 0.08);
}

.qty-box button {
  cursor: pointer;
  transition: 0.25s ease;
}

.qty-box button:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.qty-number {
  transition: 0.25s ease;
}

.qty-updating {
  opacity: 0.45;
  transform: scale(0.88);
}


/* =========================================================
   TOTAL
========================================================= */

.cart-row > .total-cell {
  grid-column: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 600;
  color: #222;
}


/* =========================================================
   DELETE BUTTON
========================================================= */

.delete-btn1 {
  width: 45px;
  height: 45px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #4c144e;
  font-size: 20px;
  cursor: pointer;
}


/* =========================================================
   CART SUMMARY
========================================================= */

.cart-summary {
  height: max-content;
  padding: 0 30px;
}

.cart-summary h2 {
  font-size: 30px;
  margin-bottom: 35px;
  font-weight: 100;
  color: rgba(77, 67, 56, 1);
}

.summary-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 28px;
}

.checkout-btn {
  width: 100%;
  height: 42px;
  background: transparent;
  border: 1px solid #111;
  color: #4c144e;
  cursor: pointer;
}


/* =========================================================
   EMPTY CART
========================================================= */

.empty-cart {
  min-height: 350px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 40px 20px;
  border-radius: 8px;
}

.empty-cart h2 {
  font-size: 30px;
  font-weight: 400;
  margin-bottom: 12px;
}

.empty-cart p {
  font-size: 15px;
  margin-bottom: 25px;
  color: #6c5a49;
}

.empty-cart-btn {
  background: #4c144e;
  color: #fff;
  border: none;
  padding: 13px 28px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 14px;
}


/* =========================================================
   MOBILE - MAX 900PX
========================================================= */

@media (max-width: 900px) {

  .cart-page {
    padding: 90px 10px 30px;
    margin-top: 50px;
    min-height: 100vh;
  }

  .cart-page.container {
    max-width: 100%;
    margin: 0 auto;
  }

  .cart-layout {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }

  .cart-table {
    width: 100%;
    border: none;
  }

  .cart-table > h1 {
    font-size: 28px !important;
    text-align: left !important;
    margin: 20px 8px;
    font-weight: 100 !important;
    color: rgba(77, 67, 56, 1);
  }

  /* Hide desktop header */

  .cart-head {
    display: none;
  }


  /* =====================================================
     MOBILE PRODUCT CARD
  ===================================================== */

  .cart-row {
    position: relative;
    display: grid;
    grid-template-columns: 100px minmax(0, 1fr) 95px;
    column-gap: 12px;
    width: 100%;
    min-height: 150px;
    background: #F2ECE5;
    border: none;
    border-radius: 10px;
    margin-bottom: 12px;
    padding: 14px 10px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  }


  /* =====================================================
     MOBILE PRODUCT IMAGE
  ===================================================== */

  .cart-cell:nth-child(1) {
    grid-column: 1;
    grid-row: 1 / 4;
    width: 100px;
    height: 110px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fafafa;
    border-radius: 10px;
    overflow: hidden;
  }

  .cart-cell:nth-child(1) > div {
    width: 100%;
    height: 100%;
  }

  .cart-img {
    width: 90px;
    height: 100px;
    object-fit: contain;
    margin: 0;
  }


  /* =====================================================
     MOBILE PRODUCT INFO
  ===================================================== */

  .cart-cell.product-info {
    grid-column: 2;
    grid-row: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    min-width: 0;
    padding: 0;
    color: #292929;
  }

  .cart-cell.product-info strong {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    font-size: 15px;
    line-height: 1.35;
    font-weight: 600;
    margin-bottom: 5px;
  }

  .product-category {
    display: block;
    font-size: 13px;
    line-height: 1.3;
    color: #777;
    font-weight: 400;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }


  /* =====================================================
     MOBILE QUANTITY + PRICE
  ===================================================== */

  .cart-cell.quantity-cell {
    grid-column: 3;
    grid-row: 1 / 4;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-start;
    padding: 0;
    gap: 8px;
  }

  .qty-box {
    width: 90px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #664e64;
    border: none;
    border-radius: 5px;
    overflow: hidden;
  }

  .qty-box button,
  .qty-number {
    width: 30px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: none;
    background: transparent;
    color: #ffffff;
    font-size: 19px;
  }

  .qty-number {
    font-size: 14px;
    font-weight: 600;
  }

  .qty-box button:disabled {
    opacity: 0.5;
  }

  .mobile-product-price {
    display: block;
    width: 90px;
    text-align: center;
    font-size: 15px;
    line-height: 1.3;
    color: #222;
    font-weight: 600;
    margin-top: 0;
  }


  /* =====================================================
     MOBILE DELETE BUTTON
  ===================================================== */

  .cart-cell:nth-child(6) {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    z-index: 5;
  }

  .cart-cell:nth-child(6)::before {
    display: none;
  }

  .delete-btn1 {
    width: 30px;
    height: 30px;
    padding: 0;
    margin: 0;
    background: transparent;
    border: none;
    color: #555;
    font-size: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .delete-btn1:hover {
    color: #4c144e;
  }


  /* =====================================================
     MOBILE CART SUMMARY
  ===================================================== */

  .cart-summary {
    width: 100%;
    background: #F2ECE5;
    border-radius: 8px;
    padding: 22px 18px;
    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);
  }

  .cart-summary h2 {
    font-size: 20px;
    margin-bottom: 22px;
    font-weight: 100;
    color: rgba(77, 67, 56, 1);
  }

  .summary-row {
    margin-bottom: 20px;
    font-size: 14px;
  }

  .checkout-btn {
    width: 100%;
    height: 48px;
    background: #664e64;
    border: none;
    border-radius: 5px;
    color: #ffffff;
    font-size: 14px;
    font-weight: 500;
  }


  /* =====================================================
     EMPTY CART
  ===================================================== */

  .empty-cart {
    min-height: 280px;
  }

  .empty-cart h2 {
    font-size: 22px;
  }

}


/* =========================================================
   SMALL MOBILE - MAX 480PX
========================================================= */

@media (max-width: 480px) {

  .cart-page {
    padding: 80px 8px 25px;
    margin-top: 45px;
  }

  .cart-table > h1 {
    font-size: 20px !important;
    margin-left: 5px;
    color:#4c144e
  }


  /* =====================================================
     SMALL MOBILE PRODUCT CARD
  ===================================================== */

  .cart-row {
    grid-template-columns: 85px minmax(0, 1fr) 88px;
    column-gap: 10px;
    min-height: 140px;
    padding: 12px 8px;
    border-radius: 8px;
  }


  /* =====================================================
     SMALL MOBILE IMAGE
  ===================================================== */

  .cart-cell:nth-child(1) {
    width: 85px;
    height: 100px;
    border-radius: 10px;
  }

  .cart-img {
    width: 80px;
    height: 90px;
  }


  /* =====================================================
     SMALL MOBILE PRODUCT INFO
  ===================================================== */

  .cart-cell.product-info strong {
    font-size: 14px;
    line-height: 1.35;
  }

  .product-category {
    font-size: 12px;
  }


  /* =====================================================
     SMALL MOBILE QUANTITY
  ===================================================== */

  .cart-cell.quantity-cell {
    gap: 7px;
  }

  .qty-box {
    width: 82px;
    height: 32px;
  }

  .qty-box button,
  .qty-number {
    width: 27px;
    height: 32px;
  }

  .qty-box button {
    font-size: 18px;
  }

  .qty-number {
    font-size: 13px;
  }


  /* =====================================================
     SMALL MOBILE PRICE
  ===================================================== */

  .mobile-product-price {
    width: 82px;
    font-size: 14px;
    text-align: center;
  }


  /* =====================================================
     SMALL MOBILE EMPTY CART
  ===================================================== */

  .empty-cart {
    min-height: 250px;
    padding: 30px 15px;
  }

  .empty-cart h2 {
    font-size: 21px;
  }

  .empty-cart p {
    font-size: 14px;
  }

  .empty-cart-btn {
    padding: 12px 22px;
  }

}
  @media (max-width: 900px) {

  .cart-row {
    position: relative;

    display: grid;

    /* IMAGE | PRODUCT INFO | QUANTITY + PRICE */
    grid-template-columns: 100px minmax(0, 1fr) 95px;

    column-gap: 12px;

    width: 100%;

    min-height: 135px;

    padding: 14px 10px;

    margin-bottom: 12px;

    background: #F2ECE5;

    border: none;

    border-radius: 10px;

    box-shadow: 0 1px 6px rgba(0, 0, 0, 0.05);

    align-items: start;
  }


  /* =========================================
     IMAGE - LEFT
  ========================================= */

  .cart-row > .cart-cell:nth-child(1) {

    grid-column: 1;

    grid-row: 1 / 4;

    width: 100px;

    height: 110px;

    padding: 0;

    display: flex;

    align-items: center;

    justify-content: center;

    background: transparent;

    border-radius: 10px;

    overflow: hidden;
  }

  .cart-img {

    width: 90px;

    height: 100px;

    object-fit: contain;

    margin: 0;
  }


  /* =========================================
     PRODUCT NAME + CATEGORY - MIDDLE
  ========================================= */

  .cart-row > .product-info {

    grid-column: 2;

    grid-row: 1;

    display: flex;

    flex-direction: column;

    align-items: flex-start;

    justify-content: flex-start;

    min-width: 0;

    padding: 0;

    margin: 0;
    margin-top:5px
  }

  .product-info strong {

    display: -webkit-box;

    -webkit-line-clamp: 2;

    -webkit-box-orient: vertical;

    overflow: hidden;

    font-size: 15px;

    line-height: 1.35;

    font-weight: 600;

    color: #292929;

    margin: 0 0 5px 0;
  }

  .product-category {

    display: block;

    font-size: 13px;

    line-height: 1.3;

    color: #777;

    font-weight: 400;

    max-width: 100%;

    white-space: nowrap;

    overflow: hidden;

    text-overflow: ellipsis;
  }


  /* =========================================
     QUANTITY + PRICE - RIGHT SIDE
  ========================================= */

  .cart-row > .quantity-cell {

    grid-column: 3;

    grid-row: 1;

    display: flex;

    flex-direction: column;

    align-items: flex-end;

    justify-content: flex-start;

    padding: 0;

    margin: 0;
    margin-top:5px
    gap: 7px;
  }


  /* QUANTITY BOX */

  .qty-box {

    width: 90px;

    height: 34px;

    display: flex;

    align-items: center;

    justify-content: space-between;

    background: #664e64;

    border: none;

    border-radius: 5px;

    overflow: hidden;
  }

  .qty-box button,

  .qty-number {

    width: 30px;

    height: 34px;

    display: flex;

    align-items: center;

    justify-content: center;

    padding: 0;

    border: none;

    background: transparent;

    color: #ffffff;

    font-size: 19px;
  }

  .qty-number {

    font-size: 14px;

    font-weight: 600;
  }


  /* PRICE BELOW QUANTITY */

  .mobile-product-price {

    display: block;

    width: 90px;

    margin: 0;

    font-size: 15px;

    line-height: 1.3;

    color: #222;

    font-weight: 600;

    text-align: center;
  }


  /* =========================================
     HIDE DESKTOP TOTAL
  ========================================= */

  .cart-row > .total-cell {

    display: none;
  }


  /* =========================================
     DELETE BUTTON
  ========================================= */

  .cart-row > .cart-cell:nth-child(6) {

    position: absolute;

    top: 8px;

    right: 8px;

    width: 25px;

    height: 25px;

    padding: 0;

    display: flex;

    align-items: center;

    justify-content: center;

    z-index: 10;
  }

  .delete-btn1 {

    width: 25px;

    height: 25px;

    padding: 0;

    margin: 0;

    background: transparent;

    border: none;

    color: #555;

    font-size: 18px;

    display: flex;

    align-items: center;

    justify-content: center;
  }

}


/* =========================================
   SMALL MOBILE - 480PX
========================================= */

@media (max-width: 480px) {

  .cart-row {

    grid-template-columns: 85px minmax(0, 1fr) 82px;

    column-gap: 8px;

    min-height: 125px;

    padding: 12px 8px;

    border-radius: 8px;
  }


  /* IMAGE */

  .cart-row > .cart-cell:nth-child(1) {

    width: 85px;

    height: 100px;

    border-radius: 10px;
  }

  .cart-img {

    width: 85px;

    height: 90px;
  }


  /* NAME */

  .product-info strong {

    font-size: 14px;

    line-height: 1.35;
  }


  /* CATEGORY */

  .product-category {

    font-size: 12px;
  }


  /* QUANTITY */

  .cart-row > .quantity-cell {

    gap: 6px;
  }

  .qty-box {

    width: 82px;

    height: 32px;
  }

  .qty-box button,

  .qty-number {

    width: 27px;

    height: 32px;
  }

  .qty-box button {

    font-size: 18px;
  }

  .qty-number {

    font-size: 13px;
  }


  /* PRICE */

  .mobile-product-price {

    width: 82px;

    font-size: 14px;

    text-align: center;
  }
.cart-row > .quantity-cell {
  grid-column: 3;
  grid-row: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  gap: 7px;
  margin-top:5px
}

.mobile-product-price {
  display: block;
  width: 90px;
  margin: 0;
  font-size: 15px;
  line-height: 1.3;
  color: #222;
  font-weight: 600;
  text-align: center;
}

/* Hide desktop price on mobile */
.cart-row > .total-cell {
  display: none;
}
}
/* =========================================
   MOBILE PRICE - HIDDEN ON DESKTOP
========================================= */

.mobile-product-price {
  display: none;
}


/* =========================================
   DESKTOP PRICE
========================================= */

.total-cell {
  display: flex;
}


/* =========================================
   MOBILE
========================================= */

@media (max-width: 900px) {

  /* Hide desktop price */
  .cart-row > .total-cell {
    display: none;
  }

  /* Show mobile price */
  .mobile-product-price {
    display: block;
    width: 90px;
    margin: 0;
    font-size: 15px;
    line-height: 1.3;
    color: #222;
    font-weight: 600;
    text-align: right;
  }

}
  .qty-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border: 1px solid #664e64;
    overflow: hidden;
    height: 30px;
    width: 78px;
            background: #664e64;
}
           .qty-box button, .qty-number {
    width: 38px;
    height: 38px;
    background: transparent;
    color: #fff;
}


/* Show category only on mobile */
@media (max-width: 900px) {
  .product-category {
    display: block;
    font-size: 13px;
    line-height: 1.3;
    color: #777;
    font-weight: 400;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
  /* =========================
   DESKTOP
========================= */

/* Hide mobile category on desktop */
.mobile-category {
  display: none;
}

/* Show desktop category */
.desktop-category {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
  @media (max-width: 900px) {

  /* Show category inside product info */
  .mobile-category {
    display: block;
  }

  /* Hide separate desktop category column */
  .desktop-category {
    display: none !important;
  }

}
`}</style>

<Header/>

<section className="cart-page container">
  {/* <h1>Your Cart</h1> */}
  {loading ? (
  <div className="empty-cart">
    <h2>Loading cart...</h2>
  </div>
) : cart.length === 0 ? (
  <div className="empty-cart">
    <h2 >Your cart is empty</h2>
    <p>Add products to your cart and continue shopping.</p>

    <button
      className="empty-cart-btn"
      onClick={() => navigate("/shop-all")}
    >
      Add Product
    </button>
  </div>
) : (
  <>
  
  <div className="cart-layout">

    <div className="cart-table">
     <h1 style={{fontWeight:"100" }}>Your Cart</h1> 
      <div className="cart-head">
  <div className="cart-cell">Product</div>
  <div className="cart-cell"></div>
  <div className="cart-cell">Category</div>
  <div className="cart-cell">Quantity</div>
  <div className="cart-cell">Price</div>
</div>

      {cart.map((item) => (
        <div className="cart-row" key={item.cart_id}>

         <div className="cart-cell">
  <div
    onClick={() => navigate(`/product/${item.product_slug}`)}
    style={{
      cursor: "pointer",
      width: "100%",
      height: "100%",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    }}
  >
    <img
      className="cart-img"
      src={`https://aethearia.store/superadmin/uploads/products/Hero/${item.hero_image}`}
      alt={item.product_name}
    />
  </div>
</div>
{/* Product Name + Category */}
<div className="cart-cell product-info">
  <strong>{item.product_name}</strong>

  {/* Mobile category */}
  <span className="product-category mobile-category">
    {item.category_name || item.category || "Category"}
  </span>
</div>

{/* Desktop category */}
<div className="cart-cell product-category desktop-category">
  {item.category_name || item.category || "Category"}
</div>

{/* Quantity */}
<div className="cart-cell quantity-cell">
  <div className="qty-box">
    <button
      onClick={() =>
        updateCartQty(
          item.cart_id,
          Number(item.quantity) - 1
        )
      }
      disabled={updatingQtyId === item.cart_id}
    >
      -
    </button>

    <div className="qty-number">
      {item.quantity}
    </div>

    <button
      onClick={() =>
        updateCartQty(
          item.cart_id,
          Number(item.quantity) + 1
        )
      }
      disabled={updatingQtyId === item.cart_id}
    >
      +
    </button>
  </div>
    <span className="mobile-product-price">
    ₹{Number(item.price).toLocaleString("en-IN")}
  </span>
</div>


{/* Total */}
<div className="cart-cell total-cell">
  ₹{item.price}
</div>


        </div>
      ))}

    </div>

    <div className="cart-summary">
      <h2>Cart Summary</h2>

      <div className="summary-row">
        <span>Sub total</span>
        <span>
          ₹
          {Number(subtotal).toLocaleString("en-IN", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })}
        </span>
      </div>

      <button
        className="checkout-btn"
        onClick={() => navigate("/checkout")}
      >
        ✔ Proceed to checkout
      </button>
    </div>

  </div>
  </>
  
  )}
</section>

<Footer/>

</>
)
}

export default CartPage;